const menuDropdowns = ($el) => {
    if (typeof $el !== 'undefined' && $el != null) {
        const $dropdownToggles = [...$el.querySelectorAll('.js-dropdown-toggle')]
        const $locationToggles = [...$el.querySelectorAll('.js-location-toggle')]
        const isActiveClass = 'is-active'

        if ($dropdownToggles) {
            $dropdownToggles.forEach($toggle => {
                $toggle.addEventListener('click', (e) => {
                    e.preventDefault()
                    /**
                     * Get target dropdown menu
                     */
                    const $dropdownMenu = $toggle.parentNode.querySelector('.js-dropdown-menu')
                    
                    $toggle.classList.toggle(isActiveClass)

                    let ariaExpanded = $toggle.getAttribute('aria-expanded')
                    if (ariaExpanded === 'false') {
                        $toggle.setAttribute('aria-expanded', 'true')
                    }

                    if (ariaExpanded === 'true') {
                        $toggle.setAttribute('aria-expanded', 'false')
                    }

                    $dropdownMenu.classList.toggle('hidden')
                })
            })
        }

        if ($locationToggles) {
            $locationToggles.forEach($toggle => {
                $toggle.addEventListener('click', () => {
                    const $carparkLocationDropdown = $toggle.parentNode.querySelector('.js-carpark-location')

                    $toggle.classList.toggle(isActiveClass)

                    let ariaExpanded = $toggle.getAttribute('aria-expanded')
                    if (ariaExpanded === 'false') {
                        $toggle.setAttribute('aria-expanded', 'true')
                    }

                    if (ariaExpanded === 'true') {
                        $toggle.setAttribute('aria-expanded', 'false')
                    }

                    $carparkLocationDropdown.classList.toggle('hidden')
                })
            })
        }

    }
}

export default menuDropdowns